import { cn as e } from "../shared/utils.js";
import { Accordion as t } from "@base-ui/react/accordion";
import { mergeProps as n } from "@base-ui/react/merge-props";
import { useRender as r } from "@base-ui/react/use-render";
import { ChevronDownFilledIcon as i } from "@systemeio/icons";
import { forwardRef as a } from "react";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/accordion/accordion.tsx
var c = a((e, n) => /* @__PURE__ */ o(t.Root, {
	ref: n,
	...e
})), l = a(({ className: n, ...r }, i) => /* @__PURE__ */ o(t.Item, {
	ref: i,
	className: e("border-border-card bg-bg-primary overflow-hidden rounded-xl border", "transition-base transition-shadow", "has-[button:focus-visible]:focus-ring-primary", n),
	...r
})), u = a(({ className: n, ...r }, i) => /* @__PURE__ */ o(t.Header, {
	ref: i,
	className: e("m-0 in-data-[slot=accordion-header-row]:min-w-0 in-data-[slot=accordion-header-row]:flex-1", n),
	...r
})), d = a(({ className: t, render: i, ...a }, o) => {
	let s = {
		className: e("flex items-start gap-2 px-5 py-3", t),
		"data-slot": "accordion-header-row",
		ref: o
	};
	return r({
		defaultTagName: "div",
		props: n(s, a),
		render: i
	});
}), f = a(({ className: t, render: i, ...a }, o) => {
	let s = {
		className: e("flex h-12 shrink-0 items-center gap-2", t),
		"data-slot": "accordion-actions",
		ref: o
	};
	return r({
		defaultTagName: "div",
		props: n(s, a),
		render: i
	});
});
function p({ className: t, ...n }) {
	return /* @__PURE__ */ o(i, {
		"aria-hidden": !0,
		className: e("text-icon-primary transition-base size-5 shrink-0 transition-transform group-data-panel-open:rotate-180", t),
		...n
	});
}
var m = a(({ className: n, ...r }, i) => /* @__PURE__ */ o(t.Trigger, {
	ref: i,
	className: e("group text-text-primary flex w-full items-center gap-2 p-5 text-left text-base font-semibold outline-none", "in-data-[slot=accordion-header-row]:items-start in-data-[slot=accordion-header-row]:px-0 in-data-[slot=accordion-header-row]:py-3.5", n),
	...r
})), h = a(({ className: n, ...r }, i) => /* @__PURE__ */ o(t.Panel, {
	ref: i,
	className: e("text-text-secondary h-(--accordion-panel-height) overflow-hidden text-base", "transition-base transition-[height,opacity]", "data-ending-style:h-0 data-ending-style:opacity-0 data-starting-style:h-0 data-starting-style:opacity-0", n),
	...r
})), g = a(({ className: t, ...n }, r) => /* @__PURE__ */ o("div", {
	ref: r,
	className: e("px-5 pb-5", t),
	...n
}));
c.displayName = t.Root.displayName ?? "AccordionRoot", l.displayName = t.Item.displayName, u.displayName = t.Header.displayName, m.displayName = t.Trigger.displayName, h.displayName = t.Panel.displayName, g.displayName = "AccordionContent", d.displayName = "AccordionHeaderRow", f.displayName = "AccordionActions";
var _ = Object.assign(function({ actions: e, children: t, label: n, contentProps: r, headerProps: i, itemProps: a, panelProps: _, triggerProps: v, ...y }) {
	let b = e !== void 0, x = /* @__PURE__ */ o(u, {
		...i,
		children: /* @__PURE__ */ s(m, {
			...v,
			children: [
				b && /* @__PURE__ */ o(p, {}),
				/* @__PURE__ */ o("span", {
					className: "min-w-0 flex-1 truncate",
					children: n
				}),
				!b && /* @__PURE__ */ o(p, {})
			]
		})
	});
	return /* @__PURE__ */ o(c, {
		...y,
		children: /* @__PURE__ */ s(l, {
			...a,
			children: [b ? /* @__PURE__ */ s(d, { children: [x, /* @__PURE__ */ o(f, { children: e })] }) : x, /* @__PURE__ */ o(h, {
				..._,
				children: /* @__PURE__ */ o(g, {
					...r,
					children: t
				})
			})]
		})
	});
}, {
	Root: c,
	Item: l,
	Header: u,
	HeaderRow: d,
	Trigger: m,
	Chevron: p,
	Actions: f,
	Panel: h,
	Content: g
});
//#endregion
export { _ as Accordion };
